import GoodPracticeReporter from "./components/GoodPracticeReporter";

export default GoodPracticeReporter